<template>
    <section>
        <div class="row">
            <div class="col-8">
                <div class="form-group" :class="{'is-invalid':errors.has('email')}">
                    <label><i class="fa fa-envelope"></i> E-mail</label>
                    <email-complete id="email" name="email" ref="AutoComplete" @newData="newEmail" @newGroup="newGroup"
                        @listAll="listAll" @onSelect="selectUser" :src="'/api/autocomplete-assinatura'">
                    </email-complete>
                    <div class="invalid-feedback help-block error">{{errors.first('email')}}</div>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group" :class="{'is-invalid':errors.has('tipo')}">
                    <label><i class="fa fa-pencil"></i> Tipo de assinatura</label>
                    <div class="input-group">
                        <select v-validate="{required:true}" v-model="form.assinatura_tipo" class="form-control"
                            name="tipo">
                            <option selected="selected" :value="null">{{$t('words.select')}}</option>
                            <option value="1">Assinar</option>
                            <option value="2">Aprovar</option>
                            <option value="3">Reconhecer</option>
                            <option value="4">Assinar como parte</option>
                            <option value="5">Assinar como testemunha</option>
                            <option value="6">Assinar como interveniente</option>
                            <option value="7">Acusar recebimento</option>
                            <option value="8">Dar ciência</option>
                        </select>
                        <span class="input-group-btn">
                            <button @click="addExistentUser()" class="btn btn-success btn-flat"><i
                                    class="fa fa-plus"></i></button>
                        </span>
                    </div>
                    <div class="invalid-feedback help-block error">{{errors.first('tipo')}}</div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="form-group">
                <p-check :color="appLayout.check" v-model="request.habilitar_ordem" class="p-switch p-fill">Habilitar
                    envio das assinaturas na ordem definida</p-check> <popover :title="'Ordem definida'" :content="'Marcando essa opção, os signatários deverão assinar na ordem que for configurada.'"></popover>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <table class="table table-sm table-condensed">
                    <thead>
                        <tr>
                            <th class="col-md-1">#</th>
                            <th v-if="request.habilitar_ordem">Ordem</th>
                            <th>Nome</th>
                            <th>CPF</th>
                            <th>E-mail</th>
                            <th>Celular</th>
                            <th>Tipo de Assinatura</th>
                            <th>Autenticação</th>
                            <th class="text-right"><i class="fa fa-pencil"></i></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(assinatura, i) in request.signatarios" :key="`sinagario${i}`">
                            <td><button :disabled="assinatura.loading || Boolean(assinatura.assinado)"
                                    @click="removeMail(i)" href="#" class="btn btn-sm btn-danger"><i
                                        class="fa fa-trash"></i></button>
                            </td>
                            <td v-if="request.habilitar_ordem">
                                <select v-model="assinatura.ordem" class="form-control-sm">
                                    <option v-for="(ord, o) in request.signatarios.length" :key="o+i" :value="o+1">
                                        {{o+1}}</option>
                                </select>
                            </td>
                            <td>{{assinatura.assinatura_nome}}</td>
                            <td><span
                                    v-if="assinatura.assinatura_documento">{{assinatura.assinatura_documento}}</span><span
                                    v-else>Não Informado</span></td>
                            <td>{{assinatura.assinatura_email}}</td>
                            <td>{{assinatura.assinatura_telefone}}</td>
                            <td>{{getTipoAssinatura(assinatura.assinatura_tipo, assinatura.assinado)}}
                            </td>
                            <td><span v-if="assinatura.token_tipo == 'E'">E-mail</span><span v-else>Celular</span></td>
                            <td><button :disabled="assinatura.assinado || assinatura.loading || loadingSingle"
                                    @click="edit(assinatura, i)" class="float-right btn-sm btn btn-outline-secondary">
                                    <i class="fa"
                                        :class="{'fa-edit': !assinatura.loading, 'fa-circle-o-notch fa-spin': assinatura.loading}"></i>
                                </button></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <m-add-user v-if="rendered" ref="mAddUser" :signatarios="request.signatarios"></m-add-user>
        <m-group-signatarios v-if="rendered" ref="mGroup" @insert="insertGroup" ></m-group-signatarios>
        <m-list-signatarios v-if="rendered" ref="mListSignatario" @addSignatarios="insertGroup"></m-list-signatarios>
    </section>
</template>

<script>
    import EmailComplete from '../AutoCompleteEmail';
    import mAddUser from '../file-signature/components/m-new-signatario.vue';
    import MListSignatarios from '../file-signature/components/m-list-signatarios.vue';
    import MGroupSignatarios from '../file-signature/components/m-group-signatarios.vue';
    export default {
        components: {
            EmailComplete,
            MListSignatarios,
            MGroupSignatarios,
            mAddUser,
        },
        props: {
            rendered: Boolean,
            request: {
                signatarios: [],
            }
        },
        data() {
            return {
                loading: false,
                loadingSingle: false,
                file: {},
                selectedUser: {
                    hasDocument: false,
                    assinatura_nome: null,
                    assinatura_email: null,
                    assinatura_documento: null,
                    token_tipo: 'E',
                    ordem: 1,
                    assinatura_telefone: null
                },
                form: {
                    assinatura_tipo: null,
                    file: null,
                    assinado: false,
                    loading: false,
                    signatarios: []
                }
            }
        },
        methods: {
            edit(payload, i) {
                this.editUser(payload);
                this.request.signatarios.splice(i, 1);
                this.newEmail();
            },
            editUser(payload) {
                payload.hasDocument = payload.assinatura_documento ? true : false;
                payload.ordem = payload.ordem ? payload.ordem : 1;
                payload.token_tipo = payload.token_tipo ? payload.token_tipo : 'E';
                this.$refs.mAddUser.form = payload;
            },
            focusAutocomplete() {
                $('#email')[0].children[0].children[1].focus();
            },
            selectUser(payload) {
                this.selectedUser.assinatura_nome = payload.nome;
                this.selectedUser.assinatura_email = payload.email;
                this.selectedUser.assinatura_documento = payload.documento;
                this.selectedUser.assinatura_telefone = payload.telefone;
            },
            newEmail() {
                $('#ModalAddSignatario').modal('toggle');
            },
            newGroup() {
                this.$refs.mGroup.fetchData();
                $('#ModalGrupoSignatario').modal('toggle');
            },
            validateUser(payload) {
                if (!payload.assinatura_email) {
                    toastr({
                        title: 'Insira um e-mail!',
                        icon: 'warning'
                    });
                    this.errors.add({
                        field: 'email',
                        msg: 'O campo precisa ser informado.'
                    });
                    this.focusAutocomplete();
                    throw 'invalid email';
                }
                if (this.request.signatarios.findIndex(
                        x => x.assinatura_email == payload.assinatura_email &&
                        x.assinatura_tipo == this.form.assinatura_tipo) > -1) {
                    toastr({
                        title: 'E-mail já adicionado para esse tipo de assinatura!',
                        icon: 'warning'
                    });
                    this.errors.add({
                        field: 'email',
                        msg: 'campo obrigatório!'
                    });
                    this.focusAutocomplete();
                    throw 'Email já adicionado';
                }
            },
            addUser(payload) {
                try {
                    this.validateUser(payload);
                    this.errors.remove('email');
                } catch (e) {
                    return;
                }
                this.insertUser(payload);
                $('#ModalAddUser').modal('toggle');
            },
            insertUser(payload) {
                toastr({
                    title: 'E-mail adicionado!',
                    icon: 'success'
                });
                this.request.signatarios.push(payload);
                this.focusAutocomplete();
            },
            addExistentUser() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) {
                        try {
                            this.validateUser(this.selectedUser);
                            this.errors.remove('email');
                        } catch (e) {
                            return;
                        }
                        return
                    }
                    try {
                        this.validateUser(this.selectedUser);
                        this.errors.remove('email');
                    } catch (e) {
                        return;
                    }
                    this.selectedUser.assinatura_tipo = this.form.assinatura_tipo;
                    this.insertUser(this.selectedUser);
                    this.$refs.AutoComplete.reset();
                    this.selectedUser = {
                        hasDocument: false,
                        assinatura_nome: null,
                        assinatura_email: null,
                        assinatura_documento: null,
                        token_tipo: 'E',
                        ordem: 1,
                        assinatura_telefone: null
                    }
                    this.focusAutocomplete();
                });
            },
            removeMail(id) {
                this.request.signatarios.splice(id, 1);
                toastr({
                    title: 'E-mail removido',
                    icon: 'success'
                });
            },
            listAll() {
                this.$refs.mListSignatario.show();
            },
            insertGroup(payload) {
                payload.grupo.signatarios.map(item => {
                    item.token_tipo = payload.token_tipo;
                    item.assinatura_tipo = payload.assinatura_tipo;
                    if (this.request.signatarios.findIndex(
                        x => x.assinatura_email == item.assinatura_email &&
                        x.assinatura_tipo ==  item.assinatura_tipo) == -1) {
                        this.insertUser(item);
                    }
                });
                toastr({
                    title: 'Grupo Adicionado!',
                    icon: 'success'
                });
            }
        }
    }
</script>